import { operate } from '../util/lift.js';
import { createOperatorSubscriber } from './OperatorSubscriber.js';

function map(project, thisArg) {
    return operate(function (source, subscriber) {
        var index = 0;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}

export { map };
//# sourceMappingURL=map.js.map
